interface Config {
    wrapper?: MaybeRefOrGetter<HTMLElement | undefined>;
    itemsLength?: MaybeRefOrGetter<number>;
    hasNext?: MaybeRefOrGetter<boolean>;
    onLoad?: () => void;
    threshold?: number;
    children?: MaybeRefOrGetter<HTMLElement[] | undefined>;
    disabled?: boolean;
    isSsr?: boolean;
}

export function useMrInfiniteScroll({
    wrapper,
    hasNext = false,
    onLoad,
    itemsLength = 0,
    threshold = 1,
    children,
    disabled,
    isSsr,
}: Config) {
    const observer = ref<IntersectionObserver>();
    onMounted(() => {
        if (disabled) {
            return;
        }
        observer.value = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                if (toValue(hasNext)) {
                    onLoad?.();
                    observer.value?.disconnect();
                }
            }
        });
    });

    onUnmounted(() => observer.value?.disconnect());

    watch(
        [() => toValue(itemsLength), observer],
        ([value, mounted]) => {
            if (!mounted || disabled) {
                return;
            }
            nextTick(() => {
                const wrapperValue =
                    toValue(children) || toValue(wrapper)?.children;
                if (value && wrapperValue?.length) {
                    observer.value?.observe(
                        wrapperValue[value - 1 - threshold]
                    );
                }
            });
        },
        { immediate: isSsr }
    );
}
